import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calculator, FileText, TrendingUp, Smartphone } from 'lucide-react';
import './Home.css';

const Home = () => {
  const services = [
    {
      icon: <Calculator size={48} />,
      title: 'Accounting & Bookkeeping',
      description: 'Maintenance of accurate accounting records and financial statements preparation.'
    },
    {
      icon: <FileText size={48} />,
      title: 'Tax Advisory',
      description: 'VAT and Corporate Tax registration, compliance, and advisory services.'
    },
    {
      icon: <TrendingUp size={48} />,
      title: 'ICV Advisory',
      description: 'In-Country Value program support and ICV score optimization.'
    },
    {
      icon: <Smartphone size={48} />,
      title: 'E-Invoicing Advisory',
      description: 'E-invoicing readiness assessment and compliance guidance.'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Your Trusted Partner for Business Clarity, Compliance & Growth
          </h1>
          <p className="hero-subtitle">
            Expert accounting, taxation, and advisory services tailored for businesses thriving in the UAE
          </p>
          <div className="hero-buttons">
            <Link to="/services" className="btn-primary">
              Explore Our Services
              <ArrowRight size={20} />
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview">
        <div className="section-header">
          <h2 className="section-title">Our Core Services</h2>
          <p className="section-subtitle">
            Comprehensive consulting solutions designed to help your business succeed
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card dark-hover dark-transition">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <Link to="/services" className="btn-primary">
            View All Services
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-header">
          <h2 className="section-title">Why Choose Fabsome Consulting</h2>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <h3 className="feature-title">UAE Expertise</h3>
            <p className="feature-description">
              Deep understanding of UAE regulatory requirements and business environment
            </p>
          </div>
          <div className="feature-card">
            <h3 className="feature-title">Compliance Focused</h3>
            <p className="feature-description">
              Ensuring your business meets all Federal Tax Authority regulations
            </p>
          </div>
          <div className="feature-card">
            <h3 className="feature-title">Practical Solutions</h3>
            <p className="feature-description">
              Actionable advice and support tailored to your specific business needs
            </p>
          </div>
          <div className="feature-card">
            <h3 className="feature-title">Trusted Partner</h3>
            <p className="feature-description">
              Reliable consulting services for SMEs and growing businesses
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Transform Your Business?</h2>
          <p className="cta-description">
            Get in touch with our expert team to discuss how we can help your business thrive
          </p>
          <Link to="/contact" className="btn-primary btn-large">
            Get Started Today
            <ArrowRight size={24} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;